import React, { useState, useEffect, useRef } from "react";
import Layout from "../Layout/Layout";
import {isAuthenticated} from '../auth';
import { useNavigate, Navigate ,  Link, useLocation} from "react-router-dom";
import { Link2, Languages, LayoutPanelTop, Pencil, Trash2, Plus, ChevronRight, ArrowLeft, AlertTriangle, FolderTree, GalleryHorizontal, Grid2x2, Rows3, ChevronUp, ChevronDown, ArrowUpDown, Eye, EyeOff } from "lucide-react";
import { createCategory, getCategoriesByID, deleteItemAndCategory, FirstCategory, UpadateNameCat, updateTranslationsCat, updateCategoryPosition, updateCategoryVisibility, updateCategoryMatrixMode } from "../auth/apiCategory";
import JsonAddLangueCat from "../pageInside/JsonAddLangueCat";
import Modal from 'react-bootstrap/Modal';
import { FirtIDCategory } from "../../config";
import {decryptData}  from '../auth/elakayCryptage'
import { elakay_API } from "../../config";


import "./adminPages.css"
import { elakayAutoText } from "../pageInside/dataElakay";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#d1fae5",
  red: "#ef4444", redLt: "#fee2e2",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["addCategory"]?.[key] || fallback;

function useQuery() {
    return new URLSearchParams(useLocation().search);

}

const AddCategory = (props) => {
    const {
        infoSource,
        laguangeElakay
            } = props;
  __setElakayInfoSource(infoSource);
     const {
    getButtonTitle
    } = infoSource;
    let query = useQuery();
    const navigate = useNavigate()
    const { token, a } = isAuthenticated();
    const [name, setName] = useState("");
    const [reName, setReName] = useState("");
    const category = FirtIDCategory
    const [categories, setCategories] = useState({});
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [shoosePEPC, setShoosePEPC] = useState('');
    // const [filters, setFilters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState(false);
    const [success, setSuccess] = useState(false);
    const [showDeleteAgree, setDeleteAgree] = useState(false);
    const [showEditName, setEditName] = useState(false);
    const [showCatProd, setCatProd] = useState(false);
    const [chek, setChek] = useState(false);
    const [catalogItem, setCatalogItem] = useState({})
    const [showJsonAdd, setShowJsonAdd] = useState(false)
    const [seletName, setSeletName] = useState('');
    // --- Sibling reorder (Position) state -------------------------------
    const [reorderingId, setReorderingId] = useState(null);
    const [reorderError, setReorderError] = useState("");
    const [showMoveModal, setShowMoveModal] = useState(false);
    const [moveTarget, setMoveTarget] = useState(null); // { id, name, index }
    const [movePosition, setMovePosition] = useState(0);
    // --- Visibility (eye icon) state ------------------------------------
    const [visibilityUpdatingId, setVisibilityUpdatingId] = useState(null);
    const [visibilityError, setVisibilityError] = useState("");
    // --- Matrix Mode (2x2 grid icon) state ------------------------------
    const [matrixUpdatingId, setMatrixUpdatingId] = useState(null);
    const [matrixError, setMatrixError] = useState("");
    const [createWithMatrix, setCreateWithMatrix] = useState(false);
    // See loadCategory(): guards against a stale in-flight GET overwriting
    // the result of a more recent one.
    const categoryRequestIdRef = useRef(0);
    const handl = (a) => {
        setChek(a)
    }
    const calculateFontSize = (index, totalElements) => {
    const maxSize = 14;
    const minSize = 11;
    const sizeStep = (maxSize - minSize) / (totalElements - 1);
    return maxSize - (index * sizeStep);
  };

const elakayCategoryID = query.get("i")? query.get("i"): categories._id ? categories._id : category;
const {
    items = [],
    filter = []
    } = categories

    useEffect(() => {
        loadCategory(elakayCategoryID)
    },[elakayCategoryID])

const createFirstCategory =(token)=>{
    FirstCategory(token, { _id: FirtIDCategory, name: [__elakayText("t008", "Elakay Categories")], categoryID: [category], owner: a}).then(data => {
        if (data.error) {
        } else {
            loadCategory(FirtIDCategory)
        }
    });
}

    const loadCategory = async (ID) => {
        setLoading(true)

        // requestId guards against a slower, in-flight call (e.g. the reload
        // after a position/rename/create save) resolving AFTER a newer one
        // and overwriting fresher state with stale data -- only the most
        // recently *started* call is allowed to setCategories().
        const requestId = ++categoryRequestIdRef.current;

            try {
                // includeHidden: addCategory.jsx is the admin page -- it must
                // keep showing disabled categories/sub-categories so they
                // stay administrable/reactivatable, unlike every public
                // consumer of this same endpoint.
                const encryptedData = await getCategoriesByID(ID, { includeHidden: true });
                const data = encryptedData;
                if (requestId !== categoryRequestIdRef.current) return;
                if (data.error) {
                ID ===  FirtIDCategory  &&  createFirstCategory(token, ID)
                throw new Error(data.error)
                } else {
                setCategories(data.cartegory)
                setName('')
                }
                } catch (err) {
                    console.error("Erreur lors du chargement de l'utilisateur :", err);
                } finally {
                    // Previously only cleared on the success branch -- any
                    // transient error left `loading` stuck at true forever,
                    // and Layout fully replaces this page's content with a
                    // full-page spinner while loading===true, so a single
                    // failed reload (e.g. right after a successful position
                    // save) could make the page look permanently stuck even
                    // though the save itself had already persisted fine.
                    if (requestId === categoryRequestIdRef.current) setLoading(false)
                }
    };

let urlLink = `/filter/${categories.publicId || categories._id}`;

    const handleChange = e => {
        setError('');
        setName(e.target.value);
    };

    const handleChangeRe = e => {
        setError('');
        setReName(e.target.value);
    };

    const deleteItCat = (name, elakayCategoryID, subCategoryID) => {
        deleteItemAndCategory(elakayCategoryID, subCategoryID, token).then(data => {
            if (data.error) {
                setError(data.error);
                // loadCategory(categoryID)
            } else {
                infoSource.loadCategory(category)
                setError(false);
                setSuccess(true);
                setMessage(elakayAutoText("h_db134a7a9f83ba", "sub Items name {value0} is deleted in {value1}", { value0: name[0], value1: categories.name[0] }))
                loadCategory(elakayCategoryID)
                setDeleteAgree(false)
                setChek(false)

            }
        });
    };

    const clickSubmit = e => {
        e.preventDefault();

        setError("");
        setSuccess(false);
        // make request to api to create category
        createCategory(token, { name, matrixMode: createWithMatrix }, elakayCategoryID).then(data => {
            if (data.error) {
                // loadCategory(elakayCategoryID);
                setError(data.error);
            } else {
               infoSource.loadCategory(category)
                setError("");
                 setSuccess(true);
                setMessage(elakayAutoText("h_58a75967a167cf", "sub Items name: {value0} is Create in {value1}", { value0: name, value1: categories.name }))
                setCreateWithMatrix(false)
                loadCategory(elakayCategoryID, token);
            }
        });
    };

    const submitJsonInput =(value)=>{

        try {
            updateTranslationsCat(token, JSON.parse(value.getJsonInput), value.id ).then(data => {
                if (data.error) {
                    value.setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }))
                } else {
                    setShowJsonAdd(false)
                    infoSource.loadCategory(category)
                    loadCategory(value.id);
                    value.setErrorMessage(null)
                }
            });
        // setNewObejet(JSON.stringify(obj,  null, 3))
        value.setErrorMessage(null)
      //
        } catch (error) {
      // Afficher l'erreur si le parsing échoue
      value.setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
      }
      }

    const clickSubmitEdit = (name, id, subId) => {

        UpadateNameCat(token, { newName :reName,  oldName : name[0]}, subId).then(data => {
            if (data.error) {
                setError(data.error);
            } else {
                infoSource.loadCategory(category)
                setError("");
                 setSuccess(true);
                setMessage(elakayAutoText("h_9248b22a5ada7d", "Items name: {value0} replaced by {value1}", { value0: name, value1: reName }))
                loadCategory(id);
                setReName('')
            }
        });
    };
    const categoryLink = elakayCategoryID =>{
        loadCategory(elakayCategoryID);
            // setBackID(elakayCategoryID)
        }

    const clickBack = (elakayCategoryID) => {
        loadCategory(elakayCategoryID)

    }

    const ButLoadCat = (a, b) => {
        loadCategory(a, b);
    }
    const ButtonLink = () => {
        navigate(urlLink)

    }
    const SubmitB = (name) => {
        setSeletName(name)
        setDeleteAgree(true)
        setEditName(false)
    }

    const SubmitA = (name) => {
        setSeletName(name)
        setDeleteAgree(false)
        setEditName(true)

    }

    // --- Sibling reorder (Position) --------------------------------------
    // The server is the source of truth: it re-derives the parent and the
    // current position from MongoDB itself, so this only ever sends
    // {categoryId, newPosition} -- never an oldPosition computed here.
    const performMove = (subCategoryID, newPosition) => {
        if (reorderingId) return;
        setReorderError("");
        setReorderingId(subCategoryID);
        updateCategoryPosition(token, subCategoryID, newPosition).then(data => {
            setReorderingId(null);
            if (!data || data.error || data.success === false) {
                setReorderError((data && data.error) || __elakayText("t019", "Unable to update position"));
            } else {
                setShowMoveModal(false);
                setMoveTarget(null);
                setError("");
                setSuccess(true);
                setMessage(__elakayText("t018", "Position updated successfully"));
                loadCategory(elakayCategoryID);
            }
        });
    };

    const moveUp = (subCategoryID, index) => {
        if (index <= 0) return;
        performMove(subCategoryID, index - 1);
    };

    const moveDown = (subCategoryID, index) => {
        if (index >= items.length - 1) return;
        performMove(subCategoryID, index + 1);
    };

    const openMoveModal = (c, index) => {
        setReorderError("");
        setMoveTarget({ id: c.supCategoryID._id, name: c.supCategoryID.name, index });
        setMovePosition(index);
        setShowMoveModal(true);
    };

    const closeMoveModal = () => {
        if (reorderingId) return;
        setShowMoveModal(false);
        setMoveTarget(null);
    };

    // --- Visibility (eye icon) -------------------------------------------
    // Toggles a sub-category's OWN isVisible flag only -- never its
    // descendants (see updateCategoryVisibility backend controller). The row
    // is updated optimistically (no full reload) and rolled back on failure.
    const toggleCategoryVisibility = (subCategory) => {
        if (visibilityUpdatingId) return; // guards against double-click / overlapping requests
        const subCategoryID = subCategory._id;
        const previousIsVisible = subCategory.isVisible !== false;
        const nextIsVisible = !previousIsVisible;

        setVisibilityError("");
        setVisibilityUpdatingId(subCategoryID);

        const applyVisibility = (isVisible) => setCategories(prev => ({
            ...prev,
            items: (prev.items || []).map(item => {
                if (String(item.supCategoryID?._id) !== String(subCategoryID)) return item;
                return {
                    ...item,
                    supCategoryID: {
                        ...item.supCategoryID,
                        isVisible,
                        effectiveVisible: isVisible && prev.effectiveVisible !== false
                    }
                };
            })
        }));

        applyVisibility(nextIsVisible);

        updateCategoryVisibility(token, subCategoryID, nextIsVisible).then(data => {
            setVisibilityUpdatingId(null);
            if (!data || data.error || data.success === false) {
                applyVisibility(previousIsVisible);
                setVisibilityError((data && data.error) || __elakayText("t024", "Unable to update visibility"));
            } else {
                setError("");
                setSuccess(true);
                setMessage(nextIsVisible
                    ? __elakayText("t025", "Category is now visible")
                    : __elakayText("t026", "Category is now hidden"));
            }
        });
    };
    // --- Matrix Mode (2x2 grid icon) --------------------------------------
    // Toggles ONE category's own matrixMode flag. It never changes that
    // category's own image: it switches how its DIRECT children are shown
    // on All Categories (their 4 best-selling products in a 2x2 grid instead
    // of their stored image). Never cascades -- each parent keeps its own
    // setting. Optimistic, rolled back on failure (same as visibility).
    // `isCurrent` = the category this page is showing (the root's own
    // toggle next to its title), otherwise one of its rows.
    const toggleCategoryMatrixMode = (target, isCurrent = false) => {
        if (matrixUpdatingId) return; // guards against double-click / overlapping requests
        const targetID = target._id;
        const previousMatrixMode = target.matrixMode === true;
        const nextMatrixMode = !previousMatrixMode;

        setMatrixError("");
        setMatrixUpdatingId(targetID);

        const applyMatrixMode = (matrixMode) => setCategories(prev => isCurrent
            ? { ...prev, matrixMode }
            : {
                ...prev,
                items: (prev.items || []).map(item => (
                    String(item.supCategoryID?._id) === String(targetID)
                        ? { ...item, supCategoryID: { ...item.supCategoryID, matrixMode } }
                        : item
                ))
            });

        applyMatrixMode(nextMatrixMode);

        updateCategoryMatrixMode(token, targetID, nextMatrixMode).then(data => {
            setMatrixUpdatingId(null);
            if (!data || data.error || data.success === false) {
                applyMatrixMode(previousMatrixMode);
                setMatrixError((data && (data.error || data.message)) || __elakayText("t036", "Unable to update Matrix Mode"));
            } else {
                setError("");
                setSuccess(true);
                setMessage(nextMatrixMode
                    ? __elakayText("t034", "Matrix Mode enabled: child categories now show their top-selling products")
                    : __elakayText("t035", "Matrix Mode disabled: child categories show their default images"));
            }
        });
    };

    // OFF = gray icon + gray button, ON = green icon + green button.
    // A terminal category (has product filters, no sub-categories) has no
    // children to illustrate: the button stays visible but disabled there
    // (unless it is somehow ON already, so it can still be turned off).
    const matrixModeButton = (target, { isCurrent = false } = {}) => {
        const isOn = target?.matrixMode === true;
        const isTerminal = target?.filter?.length > 0 && !(target?.items?.length > 0);
        const isBusy = matrixUpdatingId === target?._id;
        const isDisabled = isBusy || (isTerminal && !isOn);
        const label = __elakayText("t031", "Matrix Mode — Display child categories with top-selling product images");
        const stateText = isOn ? __elakayText("t032", "Matrix Mode: ON") : __elakayText("t033", "Matrix Mode: OFF");
        const title = isTerminal && !isOn ? `${label}\n${__elakayText("t037", "No sub-categories to illustrate")}` : `${label}\n${stateText}`;
        return (
            <button
              type="button"
              onClick={() => toggleCategoryMatrixMode(target, isCurrent)}
              disabled={isDisabled}
              aria-pressed={isOn}
              aria-label={`${label} (${stateText})`}
              title={title}
              data-testid={`matrix-mode-${target?._id}`}
              style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8,
                border: `1px solid ${isOn ? D.green : D.border}`,
                background: isOn ? D.greenLt : "#f1f5f9",
                color: isOn ? D.green : D.txt3,
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.5 : 1,
                boxSizing: "border-box", flexShrink: 0,
              }}
            >
              <Grid2x2 size={15} />
            </button>
        );
    };

    const e1 = items?.length  > 0? true: false;
    const isRootCategory = String(categories._id) === String(FirtIDCategory);
    const f1 = filter?.length > 0? true: false;

    // ─── Shared primitives ───────────────────────────────────────────────────
    const showSuccess = () => !success ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.greenLt, borderRadius: 8, border: "1px solid #86efac", marginBottom: 14 }}>
        <span style={{ fontSize: 12, color: "#065f46", fontWeight: 500 }}>{message}</span>
      </div>
    );

    const showError = () => !error ? null : (
      <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 14 }}>
        <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
        <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{error}</span>
      </div>
    );

        const deleteAgree = (name, CadegoriesID, supCategoryID, i ) => (
            <Modal key={i} show={showDeleteAgree} onHide={() => setDeleteAgree(false)} centered aria-labelledby="delete-category-title">
                <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
                  <Modal.Title id="delete-category-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.redLt, color: "#991b1b", flexShrink: 0 }}>
                      <Trash2 size={16} />
                    </span>
                    <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
                      {infoSource.language(infoSource, "title", "delThtems")}
                    </span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
                  <p style={{ fontSize: 13, color: D.txt2 }}>
                    {infoSource.language(infoSource, "title", "surToDelete")}
                    <span style={{ color: D.red, fontWeight: 700 }}> {name[0]}</span>
                  </p>
                  <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: D.txt2, cursor: "pointer" }}>
                    <input
                        onChange={() => handl(chek ? false : true)}
                        type="checkbox"
                        checked={chek}
                        style={{ width: 16, height: 16, cursor: "pointer" }}
                    />
                    {infoSource.language(infoSource, "title", "chButAgree")}
                  </label>
                </Modal.Body>
                <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
                    <button
                        onClick={chek ? () => deleteItCat(name, CadegoriesID, supCategoryID) : undefined}
                        disabled={!chek}
                        style={{
                          padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
                          fontFamily: D.font, cursor: chek ? "pointer" : "not-allowed",
                          background: chek ? D.red : "#cbd5e1", color: chek ? "#fff" : "#94a3b8",
                        }}
                    >
                        {infoSource.language(infoSource, 'Button', "submit")}
                    </button>
                </Modal.Footer>
            </Modal>
        )

        const editNameCat = (name, CadegoriesID, supCategoryID, i ) => (
            <Modal key={i} show={showEditName} onHide={() =>setEditName(false)} centered aria-labelledby="edit-category-title">
                <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
                  <Modal.Title id="edit-category-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
                      <Pencil size={16} />
                    </span>
                    <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
                      {infoSource.language(infoSource, "title", "editCategory")} {name[0]}
                    </span>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
                    <div style={{ display: "flex", gap: 10 }}>
                        <input
                            onBlur={() => setMessage("")}
                            type="text"
                            style={{ flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, outline: "none", fontFamily: D.font, boxSizing: "border-box" }}
                            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addCategory.t001}
                            onChange={handleChangeRe}
                            value={reName}
                            autoFocus
                            required
                        />
                        <button
                          onClick={() =>clickSubmitEdit(name, CadegoriesID, supCategoryID)}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 38, height: 38, borderRadius: 8, border: "none", background: D.blue, color: "#fff", cursor: "pointer", flexShrink: 0 }}
                        >
                          <Plus size={18} />
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        )

        const moveCategoryModal = () => {
            if (!moveTarget) return null;
            const lastIndex = items.length - 1;
            const preview = [...items];
            const [movedPreviewItem] = preview.splice(moveTarget.index, 1);
            preview.splice(movePosition, 0, movedPreviewItem);
            const isSaving = reorderingId === moveTarget.id;

            return (
                <Modal show={showMoveModal} onHide={closeMoveModal} centered aria-labelledby="move-category-title">
                    <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
                      <Modal.Title id="move-category-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
                          <ArrowUpDown size={16} />
                        </span>
                        <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
                          {__elakayText("t012", "Move category")}
                        </span>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
                        <p style={{ fontSize: 13, color: D.txt1, fontWeight: 600, margin: "0 0 4px" }}>{moveTarget.name?.join('; ')}</p>
                        <p style={{ fontSize: 12, color: D.txt2, margin: "0 0 12px" }}>
                            {__elakayText("t020", "Parent category")}: <strong>{categories.name?.[0]}</strong>
                        </p>

                        <p style={{ fontSize: 12, color: D.txt2, margin: "0 0 10px" }}>
                            {__elakayText("t010", "Current position")}: <strong>{moveTarget.index}</strong>
                        </p>

                        <label style={{ display: "block", fontSize: 12, color: D.txt2, marginBottom: 6, fontWeight: 600 }}>
                            {__elakayText("t011", "New position")}
                        </label>
                        <select
                            value={movePosition}
                            onChange={e => setMovePosition(Number(e.target.value))}
                            disabled={isSaving}
                            style={{ width: "100%", padding: "8px 10px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, fontFamily: D.font, marginBottom: 16, boxSizing: "border-box" }}
                        >
                            {items.map((_, i) => (
                                <option key={i} value={i}>{__elakayText("t009", "Position")} {i}</option>
                            ))}
                        </select>

                        <p style={{ fontSize: 12, color: D.txt2, fontWeight: 600, margin: "0 0 6px" }}>
                            {__elakayText("t022", "Preview order")}
                        </p>
                        <div style={{ border: `1px solid ${D.border}`, borderRadius: 8, overflow: "hidden", marginBottom: 12 }}>
                            {preview.map((p, i) => {
                                const isMoved = String(p.supCategoryID._id) === String(moveTarget.id);
                                return (
                                    <div
                                        key={p.supCategoryID._id || i}
                                        style={{
                                            display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", fontSize: 12,
                                            borderBottom: i < preview.length - 1 ? `1px solid ${D.border}` : "none",
                                            background: isMoved ? D.blueLt : "#fff",
                                            color: isMoved ? D.blue : D.txt2, fontWeight: isMoved ? 700 : 400,
                                        }}
                                    >
                                        <span style={{ minWidth: 18 }}>{i}</span>
                                        <span style={{ flex: 1 }}>{p.supCategoryID.name?.[0] || p.supCategoryID.name?.join('; ')}</span>
                                        {isMoved && <span style={{ fontSize: 11 }}>←</span>}
                                    </div>
                                );
                            })}
                        </div>

                        {reorderError && (
                          <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 4 }}>
                            <AlertTriangle size={14} color="#991b1b" style={{ flexShrink: 0 }} />
                            <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{reorderError}</span>
                          </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
                        <button
                          onClick={closeMoveModal}
                          disabled={isSaving}
                          style={{ padding: "9px 18px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, fontWeight: 600, fontFamily: D.font, background: "#fff", color: D.txt2, cursor: isSaving ? "not-allowed" : "pointer" }}
                        >
                            {__elakayText("t016", "Cancel")}
                        </button>
                        <button
                          onClick={() => performMove(moveTarget.id, movePosition)}
                          disabled={isSaving || movePosition === moveTarget.index || movePosition < 0 || movePosition > lastIndex}
                          style={{
                            padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600, fontFamily: D.font,
                            cursor: (isSaving || movePosition === moveTarget.index) ? "not-allowed" : "pointer",
                            background: (isSaving || movePosition === moveTarget.index) ? "#cbd5e1" : D.blue,
                            color: (isSaving || movePosition === moveTarget.index) ? "#94a3b8" : "#fff",
                          }}
                        >
                            {isSaving ? __elakayText("t017", "Updating position...") : __elakayText("t015", "Save position")}
                        </button>
                    </Modal.Footer>
                </Modal>
            );
        };

    const handPEPC = (a) => {
    setShoosePEPC(a)
    }

     const UpadateNameCa3 = (token, name, CategoryID) => {
        return fetch(`${elakay_API}/categories/UpadateNameCat/${CategoryID}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(name)
        })
            .then(response => {
                return response.json();
            })
            .catch(err => {
                 console.error("Erreur lors du chargement :", err);
        return {
          success: false,
          error: err.message || "Une erreur inconnue est survenue"
        };
            });
    };

const clickSubmitPage = (shoosePEPC, CatID) => {
      return fetch(`${elakay_API}/categories/UpadatePageCatPro/${CatID}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({PEPCData : shoosePEPC})
        })
            .then(response => {
                setCatProd(false)
                setShoosePEPC('')
                // Refresh so the next open pre-selects the saved layout.
                loadCategory(elakayCategoryID)
            })
            .catch(err => {
                 console.error("Erreur lors du chargement :", err);
        return {
          success: false,
          error: err.message || "Une erreur inconnue est survenue"
        };
            });
    };

const pageLayoutOptions = [
    { id: 'AAA', name: 'PageAAA', icon: GalleryHorizontal, label: __elakayText("t005", "Page with horizontal swiper") },
    { id: 'AAB', name: 'PageAAC', icon: Rows3, label: __elakayText("t006", "Promo categories in round design") },
    { id: 'AAC', name: 'PageAAC', icon: Grid2x2, label: __elakayText("t007", "4 best-sellers per category in square layout") },
];

const addPageCatProduct = () => (
    <Modal show={showCatProd} onHide={() =>setCatProd(false)} centered aria-labelledby="page-layout-title">
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="page-layout-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
              <LayoutPanelTop size={16} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addCategory.t002}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
              {pageLayoutOptions.map(({ id, name, icon: Icon, label }) => {
                const checked = shoosePEPC === id;
                return (
                  <label
                    key={id}
                    htmlFor={`Page${id}`}
                    style={{
                      display: "flex", alignItems: "center", gap: 10, padding: 12, borderRadius: 10, cursor: "pointer",
                      border: `2px solid ${checked ? D.blue : D.border}`, background: checked ? D.blueLt : "#fff",
                    }}
                  >
                    <input
                      onChange={()=>handPEPC(id)}
                      name={name}
                      type="radio"
                      checked={checked}
                      id={`Page${id}`}
                      style={{ width: 16, height: 16, cursor: "pointer", flexShrink: 0 }}
                    />
                    <Icon size={16} color={checked ? D.blue : D.txt3} style={{ flexShrink: 0 }} />
                    <span style={{ fontSize: 13, color: D.txt1, fontWeight: checked ? 600 : 400 }}>{label}</span>
                  </label>
                );
              })}
            </div>
            <button
              onClick={() =>clickSubmitPage(shoosePEPC, catalogItem.subCategory_id)}
              style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: D.blue, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
            >
              {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addCategory.t003}
            </button>
        </Modal.Body>
    </Modal>
)

const BntCatLinkToCat =(link)=>{
    return <Navigate replace to={link} />
}

const btnTranslateCat =(value)=>{
    setShowJsonAdd(true)
    setCatalogItem(value)
}

const btnAddPageCatProd =(value)=>{
    setShoosePEPC(value.PEPCData || '')
    setCatProd(true)
    setCatalogItem(value)
}

    const ButtonBackCategory = () => {
        let last_le = categories.categoryID?.length > 1 ? categories.categoryID[1] : categories.categoryID[0]
        return (
            <button
              type="button"
              onClick={() => clickBack(last_le)}
              title={getButtonTitle("addNewAddress")}
              style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 30, height: 30, borderRadius: 8, border: "none", background: "transparent", color: D.txt2, cursor: "pointer", flexShrink: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = D.bg; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
            >
                <ArrowLeft size={18} />
            </button>
        )
    }

    const CategoryFom = () => (
        <div>
            <div style={{ marginBottom: 16 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    {ButtonBackCategory()}
                    <h1 style={{ fontSize: 19, fontWeight: 700, color: D.txt1, margin: 0 }}>{categories.name[0]}</h1>
                    {/* The root "Elakay Categories" has no parent row, so its own
                        translation / page-layout actions live next to its title.
                        marginRight = row padding (16) + edit & delete buttons
                        (2 x 28) + their gaps (2 x 10), so both icons sit right
                        above the rows' own Languages / LayoutPanelTop column. */}
                    {isRootCategory && (
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginLeft: "auto", marginRight: 92 }}>
                        <button
                          type="button"
                          onClick={()=>btnTranslateCat({name: categories.name, category_id: categories._id, subCategory_id: categories._id, lang: categories.lang})}
                          title={getButtonTitle("addLangCategory")}
                          aria-label={getButtonTitle("addLangCategory")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Languages size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={()=>btnAddPageCatProd({name: categories.name, category_id: categories._id, subCategory_id: categories._id, lang: categories.lang, PEPCData: categories.PEPCData})}
                          title={getButtonTitle("selectPageCategory")}
                          aria-label={getButtonTitle("selectPageCategory")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <LayoutPanelTop size={15} />
                        </button>
                        {matrixModeButton(categories, { isCurrent: true })}
                      </div>
                    )}
                </div>

                <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, marginTop: 8, marginLeft: 40 }}>
                    {categories.name?.map((name, index) => (
                        index !== 0 && (
                          <span key={index} style={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <span
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                              onClick={() => clickBack(categories.categoryID[index])}
                              style={{ cursor: "pointer", color: hoveredIndex === index ? D.blue : D.txt3, fontSize: `${calculateFontSize(index, categories.name?.length)}px`, fontWeight: 500 }}
                            >
                              {name}
                            </span>
                            {index < categories.name?.length - 1 && <ChevronRight size={12} color={D.txt3} />}
                          </span>
                        )
                    ))}
                </div>
                {showSuccess()}
                {showError()}
                {reorderError && !showMoveModal && (
                  <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginTop: 10 }}>
                    <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
                    <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{reorderError}</span>
                  </div>
                )}
                {visibilityError && (
                  <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginTop: 10 }}>
                    <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
                    <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{visibilityError}</span>
                  </div>
                )}
                {matrixError && (
                  <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginTop: 10 }}>
                    <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
                    <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{matrixError}</span>
                  </div>
                )}
            </div>

            <div className="admin-card" style={{ overflow: "hidden" }}>

                {items?.map((c, i) => {
                    // Missing on categories saved before this field existed --
                    // never `if (isVisible)`, that would treat old data as hidden.
                    const ownVisible = c.supCategoryID.isVisible !== false;
                    const effectiveVisible = c.supCategoryID.effectiveVisible !== false;
                    const hiddenByParent = ownVisible && !effectiveVisible;
                    const isTogglingThis = visibilityUpdatingId === c.supCategoryID._id;
                    return (
                    <div key={i} className="admin-row" style={{ padding: "10px 16px", borderBottom: `1px solid ${D.border}`, flexWrap: "wrap", opacity: effectiveVisible ? 1 : 0.6 }}>
                        <span title={getButtonTitle("linkCategory")} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 24, height: 24, color: c.supCategoryID.filter?.length > 0 ? D.txt3 : D.blue, flexShrink: 0 }}>
                           { c.supCategoryID.filter?.length > 0 ?
                             <span style={{ fontSize: 11 }}>—</span>
                            :
                            <Link to={`/LinkCategory/${c.supCategoryID.publicId || c.supCategoryID._id}`} style={{ color: D.blue, display: "flex" }}><Link2 size={15}/></Link>
                            }
                        </span>
                        <p
                          onClick={() => categoryLink(c.supCategoryID._id)}
                          style={{ flex: 1, minWidth: 120, fontSize: 13, color: D.txt1, fontWeight: 600, margin: 0, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}
                        >
                           {c.supCategoryID.name.join('; ')}
                           {!ownVisible && (
                             <span style={{ fontSize: 10, fontWeight: 700, color: D.red, background: D.redLt, borderRadius: 6, padding: "2px 6px" }}>
                               {__elakayText("t027", "Disabled")}
                             </span>
                           )}
                           {hiddenByParent && (
                             <span style={{ fontSize: 10, fontWeight: 700, color: D.txt3, background: D.bg, border: `1px solid ${D.border}`, borderRadius: 6, padding: "2px 6px" }}>
                               {__elakayText("t028", "Hidden by parent")}
                             </span>
                           )}
                        </p>
                        <button
                          type="button"
                          onClick={() => toggleCategoryVisibility(c.supCategoryID)}
                          disabled={isTogglingThis}
                          title={ownVisible ? __elakayText("t029", "Visible to users") : __elakayText("t030", "Hidden from users")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: isTogglingThis ? "#cbd5e1" : (ownVisible ? D.txt3 : D.red), cursor: isTogglingThis ? "not-allowed" : "pointer", opacity: isTogglingThis ? 0.6 : 1 }}
                          onMouseEnter={e => { if (!isTogglingThis) { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; } }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = isTogglingThis ? "#cbd5e1" : (ownVisible ? D.txt3 : D.red); }}
                        >
                          {ownVisible ? <Eye size={15} /> : <EyeOff size={15} />}
                        </button>

                        <button
                          type="button"
                          onClick={() => moveUp(c.supCategoryID._id, i)}
                          disabled={i === 0 || !!reorderingId}
                          title={__elakayText("t013", "Move up")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: (i === 0 || !!reorderingId) ? "#cbd5e1" : D.txt3, cursor: (i === 0 || !!reorderingId) ? "not-allowed" : "pointer" }}
                          onMouseEnter={e => { if (i !== 0 && !reorderingId) { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; } }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = (i === 0 || !!reorderingId) ? "#cbd5e1" : D.txt3; }}
                        >
                          <ChevronUp size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={() => moveDown(c.supCategoryID._id, i)}
                          disabled={i === items.length - 1 || !!reorderingId}
                          title={__elakayText("t014", "Move down")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: (i === items.length - 1 || !!reorderingId) ? "#cbd5e1" : D.txt3, cursor: (i === items.length - 1 || !!reorderingId) ? "not-allowed" : "pointer" }}
                          onMouseEnter={e => { if (i !== items.length - 1 && !reorderingId) { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; } }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = (i === items.length - 1 || !!reorderingId) ? "#cbd5e1" : D.txt3; }}
                        >
                          <ChevronDown size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={() => openMoveModal(c, i)}
                          disabled={items.length <= 1 || !!reorderingId}
                          title={__elakayText("t023", "Move")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: (items.length <= 1 || !!reorderingId) ? "#cbd5e1" : D.txt3, cursor: (items.length <= 1 || !!reorderingId) ? "not-allowed" : "pointer" }}
                          onMouseEnter={e => { if (items.length > 1 && !reorderingId) { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; } }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = (items.length <= 1 || !!reorderingId) ? "#cbd5e1" : D.txt3; }}
                        >
                          <ArrowUpDown size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={()=>btnTranslateCat({name: c.supCategoryID.name, category_id: categories._id, subCategory_id: c.supCategoryID._id, lang: c.supCategoryID.lang})}
                          title={getButtonTitle("addLangCategory")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Languages size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={()=>btnAddPageCatProd({name: c.supCategoryID.name, category_id: categories._id, subCategory_id: c.supCategoryID._id, lang: c.supCategoryID.lang, PEPCData: c.supCategoryID.PEPCData})}
                          title={getButtonTitle("selectPageCategory")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <LayoutPanelTop size={15} />
                        </button>
                        {matrixModeButton(c.supCategoryID)}
                        <button
                          type="button"
                          onClick={() => SubmitA(c.supCategoryID.name)}
                          title={getButtonTitle("editCategory")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.blueLt; e.currentTarget.style.color = D.blue; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Pencil size={15} />
                        </button>
                        <button
                          type="button"
                          onClick={() => SubmitB(c.supCategoryID.name)}
                          title={getButtonTitle("deleteCategory")}
                          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 28, height: 28, borderRadius: 8, border: "none", background: "transparent", color: D.txt3, cursor: "pointer" }}
                          onMouseEnter={e => { e.currentTarget.style.background = D.redLt; e.currentTarget.style.color = D.red; }}
                          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = D.txt3; }}
                        >
                          <Trash2 size={15} />
                        </button>

                        { showDeleteAgree && c.supCategoryID.name === seletName &&  deleteAgree(c.supCategoryID.name, categories._id, c.supCategoryID._id, i)}
                        {showEditName && c.supCategoryID.name === seletName && editNameCat(c.supCategoryID.name, categories._id, c.supCategoryID._id, i)}
                        {showMoveModal && moveTarget && String(moveTarget.id) === String(c.supCategoryID._id) && moveCategoryModal()}
                    </div>
                    );
                })}
                {!f1 &&
                <form onSubmit={clickSubmit} style={{ display: "flex", gap: 10, padding: 16 }}>
                    <input
                        onBlur={() => setMessage("")}
                        type="text"
                        style={{ flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, outline: "none", fontFamily: D.font, boxSizing: "border-box" }}
                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addCategory.t004}
                        onChange={handleChange}
                        value={name}
                        autoFocus
                        required
                    />
                    <button
                      type="button"
                      onClick={() => setCreateWithMatrix(v => !v)}
                      aria-pressed={createWithMatrix}
                      aria-label={__elakayText("t038", "Create with Matrix Mode")}
                      title={`${__elakayText("t038", "Create with Matrix Mode")}\n${createWithMatrix ? __elakayText("t032", "Matrix Mode: ON") : __elakayText("t033", "Matrix Mode: OFF")}`}
                      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 38, height: 38, borderRadius: 8, border: `1px solid ${createWithMatrix ? D.green : D.border}`, background: createWithMatrix ? D.greenLt : "#f1f5f9", color: createWithMatrix ? D.green : D.txt3, cursor: "pointer", flexShrink: 0, boxSizing: "border-box" }}
                    >
                      <Grid2x2 size={18} />
                    </button>
                    <button
                      type="submit"
                      title={getButtonTitle("submit")}
                      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 38, height: 38, borderRadius: 8, border: "none", background: D.blue, color: "#fff", cursor: "pointer", flexShrink: 0 }}
                    >
                      <Plus size={18} />
                    </button>
                </form>
                }
            </div>

        </div>
    )

    const createFilterProduct = () => (
            <button
              type="button"
              onClick={() => ButtonLink()}
              style={{ padding: "9px 18px", borderRadius: 8, border: "none", background: D.blue, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
            >
                {infoSource.language(infoSource, "Button", "creatFiltProd")}
            </button>
    )

    const createCategoryButton = () => (
            <button
              type="button"
              onClick={() => ButLoadCat(category, token)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "9px 16px", borderRadius: 8, border: `1px solid ${D.border}`, background: "#fff", color: D.txt2, fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
            >
                <FolderTree size={14} />
                {infoSource.language(infoSource, "Button", "VieElaCat")}
            </button>
    )

    const redirectUser = (a, b) => {
        if (a) {
            return <Navigate replace to={b} />
            // return window.location.href = b;
            }
           }

    const theFirstCategory =()=>(
        <button
          type="button"
          onClick={createFirstCategory}
          style={{ padding: "9px 20px", borderRadius: 8, border: "none", background: D.blue, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}
        >
            {infoSource.language(infoSource, "Button", "getStarted")}
        </button>
    )
    return (
        <Layout
            infoSource ={infoSource}
            className="container blockEl"
            SliderPunShow={false}
            loading={loading}
             {...infoSource?.allSettings?.layout}
        >
            <JsonAddLangueCat
            infoSource ={infoSource}
            showJsonAdd={showJsonAdd}
            setShowJsonAdd={setShowJsonAdd}
            catalogItem={catalogItem}
            submitJsonInput={submitJsonInput}
            />
            {addPageCatProduct()}
            <div style={infoSource.styleNav}>
            {redirectUser(f1, urlLink)}
            <div className="admin-container" style={{ fontFamily: D.font }} onBlur={() => setMessage("")}>
                {categories._id ? <>
                {CategoryFom()}
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 16, flexWrap: "wrap" }}>
                        {createCategoryButton()}
                        {!e1 && createFilterProduct()}
                </div>
                </>
                :
                theFirstCategory()
                }
            </div>
            </div>
        </Layout>
    );
};

export default AddCategory;
